import { Component,OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Result } from '../../servicios/servers.service';
import { AlertService } from "../../servicios/alert.service";
import { PersonaService } from '../../servicios/persona.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Usuario } from '../../models/Usuario';

@Component({
    selector: 'cambiarClave',
    templateUrl: 'cambiarClave.template.html'
})
export class cambiarClaveComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private PersonaService: PersonaService,
        private alertService: AlertService
    ) {  }

    ngOnInit() {

    }

    cambiarClave() {
        loading_show();
        var usuario = JSON.parse(localStorage.getItem("user"));

        var object = {
            idUsuario: usuario.id,
            password: this.model.password,
            newPassword: this.model.newPassword,
            repeatPassword: this.model.repeatPassword
        };

        this.PersonaService.cambiarclaveVerificada(object,(data: any) => {
            loading_hide();
            if (data.isOk) {

                if(data.Mensaje == "ok"){
                    this.alertService.success("Clave Actualizada Correctamente");
                    this.model = {};
    
                }else{
                    this.alertService.error(data.Mensaje);
                }
                

            }else{
                this.alertService.error("Error desconocido");
            }

            this.loading = false;            

        });
    }

 }


// WEBPACK FOOTER //
// ./src/app/views/cambiarClave/cambiarClave.component.ts